import ApiService from "@/common/api.service"

export const GraduateTrackingService = {
    getGraduateTracks() {
        return ApiService.get("/graduateTracking")
    },
    create(params) {
        return ApiService.post("graduateTracking/add", params);
    },
    update(slug, params) {
        return ApiService.update("graduateTracking", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("graduateTracking", slug, params)
    }
};